import React, { FC } from 'react';

import Card from 'components/Card';
import { CardV2, useCardV2Enabled } from 'components/CardV2';

import { CardSchema } from 'constants/graphqlTypes';
import { StyledItem, StyledList } from '../styled';

interface IDefaultViewItemProps {
  item: CardSchema;
  isDark: boolean;
  showActivity?: boolean | null;
  isProfilePicks?: boolean | null;
  fontColor?: string;
  isSmall?: boolean;
  showAddReaction?: boolean;
  gradientStartColor?: string | null;
}

const DefaultViewItem: FC<IDefaultViewItemProps> = ({
  item,
  isDark,
  showActivity,
  isProfilePicks,
  fontColor,
  isSmall,
  showAddReaction,
  gradientStartColor,
}) => {
  const useNewCard = useCardV2Enabled(item);

  if (useNewCard) {
    return (
      <CardV2
        card={item}
        headerVariant={isProfilePicks ? 'compact' : 'full'}
        overlayBackgroundColor={gradientStartColor}
      />
    );
  }

  return (
    <Card
      showActivity={showActivity}
      layout={undefined}
      card={item}
      isDark={isDark}
      isProfilePicks={isProfilePicks}
      fontColor={fontColor}
      isSmall={isSmall}
      hideActionsUserInfo
      showAddReaction={showAddReaction}
    />
  );
};

interface IDefaultViewProps {
  items: CardSchema[];
  isDark: boolean;
  showActivity?: boolean | null;
  isProfilePicks?: boolean | null;
  firstItemFontColor?: string;
  captureFirstItemRef?: (el: HTMLLIElement | null) => void;
  isSmall?: boolean;
  showAddReaction?: boolean;
  gradientStartColor?: string | null;
}

const DefaultView: FC<IDefaultViewProps> = ({
  items,
  isDark,
  showActivity,
  isProfilePicks,
  firstItemFontColor,
  captureFirstItemRef,
  isSmall,
  showAddReaction,
  gradientStartColor,
}) => (
  <StyledList>
    {items.map((item, index) => (
      <StyledItem isBig key={item.id} ref={index === 0 ? (el) => captureFirstItemRef?.(el) : undefined}>
        <DefaultViewItem
          item={item}
          isDark={isDark}
          showActivity={showActivity}
          isProfilePicks={isProfilePicks}
          fontColor={index === 0 ? firstItemFontColor : undefined}
          isSmall={isSmall}
          showAddReaction={showAddReaction}
          gradientStartColor={index === 0 ? gradientStartColor : undefined}
        />
      </StyledItem>
    ))}
  </StyledList>
);

export default DefaultView;
